"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const context_1 = require("./context");
const react_2 = require("@osmosys/react");
const react_use_1 = require("react-use");
const react_hanger_1 = require("react-hanger");
exports.ContentMappingNameInput = () => {
    const inputRef = react_1.useRef(null);
    const { contentMappingDraft: draft } = react_1.useContext(context_1.ContentMappingDetailContext);
    const [nameIsFocused, toggleNameIsFocused] = react_use_1.useToggle(false);
    const previouslyNameIsFocused = react_hanger_1.usePrevious(nameIsFocused);
    react_1.useEffect(() => {
        if (nameIsFocused && !previouslyNameIsFocused) {
            inputRef.current.focus();
        }
    }, [nameIsFocused, previouslyNameIsFocused]);
    const input = (react_1.default.createElement(reactstrap_1.Input, { value: draft.state.name || '', name: "name", placeholder: "Content mapping name", className: nameIsFocused ? '' : 'form-control-plaintext font-weight-bold', onClick: () => {
            if (!nameIsFocused) {
                toggleNameIsFocused(true);
            }
        }, onBlur: () => {
            toggleNameIsFocused(false);
        }, innerRef: inputRef, onChange: ({ target: { value } }) => {
            draft.setState({
                name: value,
            });
        } }));
    react_use_1.useClickAway(inputRef, () => {
        toggleNameIsFocused(false);
    });
    return nameIsFocused ? (input) : (react_1.default.createElement(react_2.OsmosysTooltip, { label: "Click to edit content mapping name" }, input));
};
//# sourceMappingURL=NameInput.js.map